import { selectFormById } from "@overmap-ai/core"
import { createFileRoute, notFound } from "@tanstack/react-router"
import { appStore } from "src/store"
import { NotFound } from "src/views/FormDetailsView/NotFound"
import { formSubmitterViewStaticData } from "src/views/SubmitFormView/constants"
import { SubmitFormView } from "src/views/SubmitFormView/SubmitFormView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/forms/$formId/submit")({
	component: SubmitFormView,
	notFoundComponent: NotFound,
	staticData: formSubmitterViewStaticData,
	loader: ({ params }) => {
		const form = selectFormById(params.formId)(appStore.getState())
		if (!form) throw notFound()
	},
})
